<template>
    <div id="proBehavior" class="mt4">
        <div>
            <vxe-table
                    border
                    max-height="600"
                    class="sortable-row-demo vxe-table-antd"
                    row-key
                    resizable
                    size="mini"
                    :edit-config="{ key: 'uid', trigger: 'click', mode: 'row' }"
                    ref="proBehaviorTable"
                    :data="proBehaviorData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="beType" title="Type" minWidth="20"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="beName" title="Code" minWidth="20"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="name" title="Jasper Template Name" minWidth="200" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template v-slot:edit="{ row }">
                        <a-input v-model="row.tmplName" size="small" :placeholder="$t('publicLang.PleaseEnter')"/>
                    </template>
                    <template v-slot="{ row }">{{ row.tmplName }}</template>
                </vxe-table-column>
                <vxe-table-column
                        show-header-overflow="ellipsis"
                        show-overflow="ellipsis"
                        field="isShow"
                        title="Is Show"
                        minWidth="150"
                        :edit-render="{ type: 'visible' }"
                >
                    <template v-slot:header>
                            <span><span class="mr4">Is Show</span><a-switch size="small" @change="headerIsShow" v-model="headerIsShowVis"></a-switch></span>
                    </template>
                    <template v-slot:edit="{ row, rowIndex }">
                        <a-switch v-model="row.isShow" size="small"></a-switch>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </div>

        <a-row type="flex" justify="end" class="mt">
            <a-button type="primary" size="small" @click="saveProBehavior">Save</a-button>
        </a-row>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import Sortable from "sortablejs";
    export default{
        props: {
            targetProgenericUid: {
                type: String,
                default: function () {
                    return '';
                }
            },
        },
        data(){
            return{
                proBehaviorData: [],
                headerIsShowVis: false,
            }
        },
        watch:{
            targetProgenericUid(){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
            init(){
                this.headerIsShowVis = false
                ajax.get(api.GENERICEXTGENERICGEEXTBEHR,{geExtDetailUid: this.targetProgenericUid}).then(res=>{
                    this.proBehaviorData = res.data.geExtBehrDtoList
                    if(this.proBehaviorData.length > 0){
                        for(let i in this.proBehaviorData){
                            if(this.proBehaviorData[i].isShow == 'true'){
                                this.proBehaviorData[i].isShow = true
                            }else{
                                this.proBehaviorData[i].isShow = false
                            }
                        }
                    }
                    this.$nextTick(() => {
                        let sortTable = this.$refs.proBehaviorTable
                        let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                            onEnd: ({ newIndex, oldIndex }) => {
                                let currRow = this.proBehaviorData.splice(oldIndex, 1)[0];
                                this.proBehaviorData.splice(newIndex, 0, currRow);
                            }
                        });
                    });
                })
            },
            saveProBehavior(){
                let data  = JSON.parse(JSON.stringify(this.proBehaviorData))
                for(let i in data){
                    if(data[i].isShow){
                        data[i].isShow = 'true'
                    }else{
                        data[i].isShow = 'false'
                    }
                }
                let params = {
                    geExtBehrDtoList: data
                }
                ajax.post(api.GENERICEXTGENERICGEEXTBEHR,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.init()
                    }
                })
            },
            headerIsShow(val){
                for(let i in this.proBehaviorData){
                    this.proBehaviorData[i].isShow = val
                }
            }
        }
    }
</script>